var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',[_c('font-awesome-icon',{attrs:{"slot":"icon","icon":_vm.icons.limiter},slot:"icon"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }